define(["require", "exports", "jquery", "./defer", "./canvas", "./progress", "./analytics", "./designActions", "./svg"], function (require, exports, $, defer_1, canvas_1, progress_1, analytics_1, designActions_1, svg_1) {
    "use strict";
    exports.__esModule = true;
    exports.DesignSize = {
        Width: 960,
        Height: 960
    };
    exports.ThumbSize = {
        Width: 480,
        Height: 480
    };
    function ensureImageLoaded($sel) {
        $sel.each(function (i, img) {
            var $img = $(img);
            $img.attr('src', $img.data('src'));
        });
    }
    exports.ensureImageLoaded = ensureImageLoaded;
    function startRotatingPictureShow(div) {
        var cover = div.find('.cover');
        var images = cover.data('images');
        if (!images) {
            return;
        }
        div.data('quick-view', true);
        div.on('mouseleave', function (e) {
            div.data('quick-view', false);
            var c = div.find('.cover');
            var timeout = c.data('timeout');
            if (timeout)
                clearTimeout(timeout);
            c.attr('src', images[0]).data('images', images);
            div.off('mouseleave');
        });
        switchImage(cover, images);
    }
    exports.startRotatingPictureShow = startRotatingPictureShow;
    function crossFadeImage(fromImg, toImg) {
        fromImg.toggleClass('cover', false).toggleClass('fade', true);
        toImg.toggleClass('cover', true).toggleClass('fade', false);
    }
    exports.crossFadeImage = crossFadeImage;
    function switchImage(img, images) {
        var nextImage = null;
        nextImage = images[1];
        ensureImageLoadedAsync(nextImage, function (e, loaded) {
            if (loaded) {
                var item = img.closest('.product-item');
                if (item.data('quick-view')) {
                    var nextImg = item.find('img.fade').attr('src', nextImage);
                    crossFadeImage(img, nextImg);
                }
            }
        });
    }
    exports.switchImage = switchImage;
    function rotateImages(img, images) {
        var curImage = img.attr('src');
        img.removeData('timeout');
        var nextImage = null;
        var i = 0;
        for (i = 0; i < images.length; i++) {
            if (images[i] == curImage) {
                break;
            }
        }
        if (i == images.length - 1) {
            nextImage = images[0];
        }
        else {
            nextImage = images[i + 1];
        }
        ensureImageLoadedAsync(nextImage, function (e, loaded) {
            if (loaded) {
                var item = img.closest('.product-item');
                if (item.data('quick-view')) {
                    var nextImg = item.find('img.fade').attr('src', nextImage);
                    crossFadeImage(img, nextImg);
                    var timeout = defer_1["default"](function () {
                        rotateImages(nextImg, images);
                    }, 2000);
                    nextImg.data('timeout', timeout);
                }
            }
        });
    }
    exports.rotateImages = rotateImages;
    function ensureImageLoadedAsync(src, callback) {
        $('.image-loader').attr('src', src).on('load', function (evt) {
            callback(null, true);
            $(evt.target).off('load error');
        }).on('error', function (evt) {
            callback('failed to load image', false);
            $(evt.target).off('load error');
        });
    }
    function captureImage($capture) {
        $capture = $capture || $('input[type="file"]');
        var deferred = $.Deferred();
        $capture.on('change', function (e) {
            $capture.off('change');
            var input = ($capture[0]);
            var files = input.files;
            var img = null;
            if (files && files.length) {
                var file = files[0];
                if (file.type && file.type.indexOf('image/') == 0) {
                    var objUrl = window.URL.createObjectURL(file);
                    img = document.createElement('img');
                    img.onload = function () {
                        deferred.resolve(img);
                    };
                    img.src = objUrl;
                }
            }
            if (!img) {
                deferred.reject();
            }
        });
        return deferred.promise();
    }
    exports.captureImage = captureImage;
    function toHex(val, padding) {
        padding = padding || 1;
        var result = parseInt(val).toString(16);
        while (result.length < padding) {
            result = '0' + result;
        }
        return result;
    }
    function favorBright(r, g, b) {
        return (r * r + g * g + b * b) / 65535 * 20 + 1;
    }
    function captureWallColor($capture) {
        var deferred = $.Deferred();
        captureImage($capture).then(function (img) {
            var finder = new ColorFinder(favorBright);
            var color = finder.getMostProminentColor(img);
            var colorString = '#' + toHex(color.r, 2) + toHex(color.g, 2) + toHex(color.b, 2);
            deferred.resolve(colorString);
        }).fail(function () {
            deferred.reject();
        });
        return deferred.promise();
    }
    exports.captureWallColor = captureWallColor;
    function previewImageFile($file, imgSels, onImage) {
        $file.change(function () {
            analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.create.photo.add);
            var input = $file[0];
            var $img = $(imgSels[0]);
            var index = 0;
            while ($img.length !== 1) {
                $img = $(imgSels[++index]);
            }
            if (input.files && input.files[0]) {
                var file = input.files[0];
                loadImage(file, function (img) {
                    var $newImg = $(img).attr('id', 'capturedImage');
                    $img.replaceWith($newImg);
                    onImage($newImg);
                }, {
                    maxHeight: 1280,
                    maxWidth: 1280,
                    orientation: true
                });
            }
        });
    }
    exports.previewImageFile = previewImageFile;
    function uploadImageFiles($img, action, position, color, progress) {
        if (position === void 0) { position = null; }
        var img = $img[0];
        var photoFile = null;
        var thumbFile = null;
        var formData = new FormData();
        analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.create.photo.use);
        progress_1.setState({
            visibility: 'visible',
            className: '',
            label: 'Saving...'
        });
        if (position) {
            var appendPoint = function (key) {
                formData.append("position." + key + ".X", position[key].X);
                formData.append("position." + key + ".Y", position[key].Y);
            };
            appendPoint('topLeft');
            appendPoint('topRight');
            appendPoint('bottomLeft');
            appendPoint('bottomRight');
        }
        if (color) {
            formData.append('wallColor', color);
        }
        if (progress) {
            formData.append('progress', "" + progress);
        }
        return canvas_1.scaleImageAsFile(img, 'photo.jpg', 'image/jpeg', exports.DesignSize.Width, exports.DesignSize.Height).then(function (x) {
            photoFile = x.file;
            formData.append('photo', photoFile);
            formData.append('photoSize.Width', "" + x.width);
            formData.append('photoSize.Height', "" + x.height);
            return canvas_1.scaleImageAsFile(img, 'thumb.jpg', 'image/jpeg', exports.ThumbSize.Width, exports.ThumbSize.Height);
        }).then(function (x) {
            thumbFile = x.file;
            formData.append('thumbnail', thumbFile);
            formData.append('thumbSize.Width', "" + x.width);
            formData.append('thumbSize.Height', "" + x.height);
            return $.ajax({
                url: action,
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json'
            });
        }).always(function () {
            progress_1.setState({
                visibility: 'hidden',
                className: '',
                label: 'Saved'
            });
        });
    }
    exports.uploadImageFiles = uploadImageFiles;
    exports.onePxPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
    function discardPreviewImage() {
        analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.create.photo.discard);
        var $img = $('.upload-sketch img');
        if ($img.length) {
            $('.upload-sketch img').attr('src', exports.onePxPng);
        }
        else {
            $('.upload-sketch .img-box').prepend("<img id=\"capturedImage\" src=\"" + exports.onePxPng + "\"/>");
        }
        $('.upload-sketch canvas#capturedImage').remove();
        $('.upload-sketch').toggleClass('empty', true);
        svg_1.resetBox($('.img-box #window-box')[0], $('.img-box #default-frame')[0]);
    }
    exports.discardPreviewImage = discardPreviewImage;
    function initUploadImage($file) {
        analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.create.photo.offer);
        $file.click(function (e) {
            analytics_1["default"](designActions_1.DesignCenterActions.ns, designActions_1.DesignCenterActions.create.photo.start);
            return true;
        });
    }
    exports.initUploadImage = initUploadImage;
    function handleImageRotation($img, rotate) {
        var img = $img[0];
        var newImg = canvas_1.rotatePicture(img, rotate);
        if (newImg !== img) {
            var $newImg = $(newImg);
            $newImg.attr('id', $img.attr('id'));
            $img.replaceWith($newImg);
        }
    }
    exports.handleImageRotation = handleImageRotation;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/images.js
// module id = 34
// module chunks = 0